import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const Reference = makeShortcode("Reference");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Kalahari occupies an exceedingly flat tableland taking up much of the
central part of southern  Africa. When the national gravity survey of Botswana
was mooted in 1970, absolute heights  above seal level for this remote, dry and
thinly-populated area were unavailable and precision  primary levelling was
still in progress. Earlier levelling work in pursuit of potential engineering
work on river courses (Du Toit, 1926; Brind, 1955) had proved inconclusive. A
by-product of the  national gravity survey (Reeves & Hutchins, 1976) was the
first rough topographic contour map of  Botswana derived from about 2500 heights
determined by barometric altimeters tied to the few  available reliable datum
points. The lowest point in the inland drainage basin in the Makgadikgadi  salt
flats was determined as 903 (+/- 5) metres. Almost all of northern Botswana lay
below 1000  m with the only escape for water from the annual flooding of the
Okavango delta in the NW of the  country at about 930 m, located near the
administrative centre of Maun.`}</p>
    <p>{`More recently, Shuttle imaging radar (SIR) has determined the topographic
surface with  centimetre accuracy. Geomorphological studies, linked to SIR data,
have defined old shorelines at  973 m outlining a lake that occupied most of
northern Botswana - an area about half the size of  France - in earlier pluvial
times. Archaeological studies of these ancient shorelines have revealed  copious
stone tools, relics of a Stone Age civilisation living in a much more clement
climate than  today's (Moore & Larkin, 2001). In a recent Nature publication
(Chan et al., 2019) it is claimed  that studies of mitochondrial DNA lead back
to this earthly lakeshore paradise hosting the origin of  Man. Migratory pulses
are interpreted to have left for east Africa 130 000 years ago, and for the
south 110 000 years ago.`}</p>
    <p>{`The Mwembishi fault zone (see previous news item, below) separates the ancient
lake from the  present-day watercourses of three large rivers, the Okavango, the
Cuando and the Zambezi, all  drawing their water from the Angola highlands that,
even today, enjoy higher levels of rainfall than  the Kalahari. It would seem
that movements on the Mwembishi shear zone in the Early  Cretaceous set up the
topography of southern Africa, much of which persists to the present  day.
Perhaps we should all be grateful for that!`}</p>
    <p>{`In the figure, Karoo rocks are indicated in beige and Kalahari sand cover in
pale  yellow. International boundaries are in red and the paleo-lake is shaded
in blue.`}</p>
    <PublishDate mdxType="PublishDate" />
    <h1>{`References`}</h1>
    <Reference link="https://doi.org/10.1038/s41586-019-1714-1" mdxType="Reference">
Brind, W.G., 1955. The Okavango delta: report on the 1951-3 field surveys.
Chan, E.K.F., et al., 2019. Human origins in a southern Africa paleo-wetland and
first migration. Nature.
    </Reference>
    <Reference mdxType="Reference">
Du Toit, A, 1926. Report of the Kalahari reconnaissance of 1925. Union of South
Africa, Department of Irrigation.
    </Reference>
    <Reference mdxType="Reference">
Moore, A.E., and Larkin, P.A., 2001. Drainage evolution in south-central Africa
since the break-up of Gondwana. South Africa journal of Geology, 104, 47-68.
    </Reference>
    <Reference mdxType="Reference">
Reeves, C.V. and Htuchins, D.G., 1976. The national gravity survey of Botswana,
1972- 73. Bulletin No. 3, Geological Survey Department, Botswana.
    </Reference>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      